/** Tries to extract a cad_error_* name from a failed axios response. Returns null if not a cad error. */
export function extractCadErrorName(axiosError) {
  try {
    const data = axiosError?.response?.data
    let body
    if (data instanceof ArrayBuffer) {
      body = JSON.parse(new TextDecoder().decode(data))
    } else if (typeof data === 'string') {
      body = JSON.parse(data)
    } else {
      body = data
    }
    const name = body?.name
    if (typeof name === 'string' && name.startsWith('cad_error_')) return name
    return null
  } catch {
    return null
  }
}
